/* tslint:disable */
/* eslint-disable */
/**
 * Adyen Card Enrollment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePaymentResponseDataTestData
 */
export interface CreatePaymentResponseDataTestData {
    /**
     * URL that the client should redirect to on completion. Will be intercepted by the app.
     * @type {string}
     * @memberof CreatePaymentResponseDataTestData
     */
    interceptUrl?: string;
}

export function CreatePaymentResponseDataTestDataFromJSON(json: any): CreatePaymentResponseDataTestData {
    return CreatePaymentResponseDataTestDataFromJSONTyped(json, false);
}

export function CreatePaymentResponseDataTestDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePaymentResponseDataTestData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'interceptUrl': !exists(json, 'interceptUrl') ? undefined : json['interceptUrl'],
    };
}

export function CreatePaymentResponseDataTestDataToJSON(value?: CreatePaymentResponseDataTestData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'interceptUrl': value.interceptUrl,
    };
}

